import React, { useEffect, useState } from "react";
import { FaHeart } from "react-icons/fa";
import { useAddToCartMutation, useLazyViewWishlistQuery, useWhishlistMutation, useLazyCartViewQuery, useRemovewishlistMutation, useLazyRemovewishlistQuery } from "../redux/Api/api";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveCartCountHandler } from "../redux/reducer/CartCountSlice";
import { saveWishlistCountHandler } from "../redux/reducer/WhislistCountSlice";

const WishlistPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [fetchWishlist] = useLazyViewWishlistQuery();
  const [fetchremove] = useLazyRemovewishlistQuery();
  const [addToCart] = useAddToCartMutation();
  const [cartlist] = useLazyCartViewQuery();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch()
  const [whishlist] = useLazyViewWishlistQuery();

  useEffect(() => {
    if (user && user._id) {
      fetchWishlist({ userId: user._id })
        .unwrap()
        .then((item) => {
          console.log("cated", item);

          setWishlist(item.data);

          const status = {};
          item.data.forEach((product) => {
            status[product?.productId?._id] = true;

          })
          setWishlistStatus(status);
          dispatch(saveWishlistCountHandler(item.data.length));
        })
        .catch((err) => {
          console.error("Error fetching wishlist:", err);
          toast.error(err?.data?.message || "Error fetching wishlist.");
        });
    } else {
      toast.error("Please login first");
    }
  }, [user, fetchWishlist, dispatch]);

  const getWishlistData = () => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (!storedUser?._id) return;

    whishlist(storedUser._id)
      .unwrap()
      .then((res) => {
        dispatch(saveWishlistCountHandler(res?.length));
      })
      .catch((err) => {
        console.error("Error fetching wishlist:", err);
      });
  };

  const handleremovewishlist = (productId) => {
    if (!user || !user._id) {
      toast.error("Please log in first.");
      return;
    }
    fetchremove({ userId: user._id, productId })
      .unwrap()
      .then((res) => {
        const updatedWishlist = wishlist.filter(
          (item) => item.productId._id !== productId
        );
        getWishlistData();
        setWishlist(updatedWishlist);
        dispatch(saveWishlistCountHandler(updatedWishlist.length));
        toast.success(res.message || "Product removed from wishlist successfully.");
      })
      .catch((err) => {
        console.error("Error removing product from wishlist:", err);
        toast.error(err?.data?.message || "Unable to remove product from wishlist.");
      });
  };

  const handleAddToCart = (item) => {
    const productId = item?._id;
    const user = JSON.parse(localStorage.getItem('user'));

    if (!user || !user._id) {
      toast.error("Please log in first.");
      return;
    }
    const userId = user._id;
    addToCart({ productId, userId })
      .unwrap()
      .then((res) => {
        console.log('Cartres', res);
        const storedUser = JSON.parse(localStorage.getItem('user'));
        const id = storedUser?._id
        cartlist(id).unwrap().then(res => {
          console.log('Ress', res);
          dispatch(saveCartCountHandler(res?.length))
          // const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
          // const updatedCart = [...storedCart, item];
          // localStorage.setItem('cart', JSON.stringify(updatedCart));
        })
        toast.success("Product added to cart successfully!");
      })
      .catch((err) => {
        console.error("Error adding to cart:", err);
        toast.error(err?.data?.message || "Unable to add product to cart.");
      });
  };

  const handleBuyNow = (productId) => {
    navigate(`/cart`, { state: { productId } });
  };

  return (
    <div className="p-4 lg:mt-[250px]">
      <h1 className="text-2xl font-bold mb-4">My Wishlist</h1>
      {wishlist.length === 0 ? (
        <p className="text-gray-600">Your wishlist is empty!</p>
      ) : (

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {wishlist.map((product) => (

            <div
              key={product._id}
              className="p-6 text-center rounded-lg border shadow-lg relative"
            >
              <a href={`/productview/${product._id}`}>

                <img
                  src={product?.productId?.image || "/assets/default_product_image.png"}
                  alt={product?.productId?.name || "Product image"}
                  className="w-full h-48 object-contain mb-4" />
              </a>
              <h3 className="font-semibold mt-4">
                {product?.productId?.name || "Unnamed Product"}
              </h3>
              <p className="text-sm mt-2 text-gray-700">
                {product?.productId?.description || "No description available."}
              </p>
              <p className="text-lg font-semibold mt-2">
                {product?.productId?.price ? `Rs ${product.productId.price}` : "Price not available"}
              </p>
              <button
                className="absolute top-2 right-2 text-2xl text-red-600 bg-white p-2 hover:bg-gray-200"
                onClick={() => handleremovewishlist(product.productId._id)}
              >
                <FaHeart />
              </button>
              <div className="flex justify-center mt-4">
                <button
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-500"
                  onClick={() => handleBuyNow(product._id)}
                >
                  Buy Now
                </button>
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-500 ml-2"
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
      <ToastContainer />
    </div>
  );
};
export default WishlistPage;
